module.exports = __webpack_public_path__ + "img/Wei_Wang.5961ddfb.png";